import productreducer from "./productreducer";

import { combineReducers } from "redux";


const rootReducer = combineReducers({
    productreducer
});

export default rootReducer;